type HandoffKind = 'draft' | 'gift' | 'referral';
const key = (kind: HandoffKind) => 'lm_intent_' + kind;
const lifetime = 24 * 60 * 60 * 1000;

/** Only short-lived opaque tokens are stored, never conversations or business financials. */
export function captureIntentHandoff() {
    try {
        const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));
        let changed = false;
        (['draft', 'gift', 'referral'] as HandoffKind[]).forEach((kind) => {
            const token = params.get('intent_' + kind);
            if (token && token.length <= 1000 && /^[a-zA-Z0-9_:.=-]+$/.test(token)) {
                localStorage.setItem(key(kind), JSON.stringify({ token, expires: Date.now() + lifetime }));
                params.delete('intent_' + kind);
                changed = true;
            }
        });
        if (changed)
            window.history.replaceState(
                window.history.state,
                '',
                window.location.pathname + window.location.search + (params.toString() ? '#' + params.toString() : '')
            );
    } catch {
        /* Registration stays usable with storage disabled. */
    }
}
export function readIntentHandoff(kind: HandoffKind): string | null {
    try {
        const value = JSON.parse(localStorage.getItem(key(kind)) || 'null');
        if (value && typeof value.token === 'string' && value.expires > Date.now()) return value.token;
        localStorage.removeItem(key(kind));
    } catch {
        /* Corrupt or unavailable storage. */
    }
    return null;
}
export function clearIntentHandoff(kind: HandoffKind, expectedToken?: string) {
    try {
        if (expectedToken && readIntentHandoff(kind) !== expectedToken) return;
        localStorage.removeItem(key(kind));
    } catch {
        /* Optional persistence. */
    }
}
